import { AppThunkAction } from '../reducers';
import * as Actions from '../actions';
import * as service from '../../services/MedicalProtocols.Services';
import { ErrorType } from '../../models/HttpError';

type KnownAction =
    | Actions.ProtocolPatients.ProtocolPatientsExportDerivedExcelRequestAction
    | Actions.ProtocolPatients.ProtocolPatientsExportDerivedExcelSuccessAction
    | Actions.ProtocolPatients.ProtocolPatientsExportDerivedExcelFailureAction;

export const ActionCreators = {
    ExportDerivedPatientsToExcel: (
        protocolId: number | undefined,
        dateFrom: Date | undefined,
        dateTo: Date | undefined
    ): AppThunkAction<KnownAction> => {
        return (dispatch, getState) => {
            const state = getState();
            let token: string;
            if (state.oidc?.user?.access_token === undefined) {
                dispatch({ type: 'PROTOCOLPATIENTS_EXPORT_DERIVED_EXCEL_FAILURE', error: { ErrorCode: 401, ErrorMessage: 'Not authorized', Errors: [] } });
                return;
            } else { token = state.oidc.user.access_token; }
            dispatch({ type: 'PROTOCOLPATIENTS_EXPORT_DERIVED_EXCEL_REQUEST' });
            service.ExportDerivedPatients(protocolId, dateFrom, dateTo, token)
                .then((excelBlob: Blob) => {
                    dispatch({ type: 'PROTOCOLPATIENTS_EXPORT_DERIVED_EXCEL_SUCCESS', excelBlob: excelBlob });
                })
                .catch((error: ErrorType) =>
                    dispatch({ type: 'PROTOCOLPATIENTS_EXPORT_DERIVED_EXCEL_FAILURE', error: error })
                );
        };
    }
};
